import { GET_PROPERTY_LIST, SET_REDIRECTS } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, BaseAsyncReducerState } from "../../types";

export interface PropertyListState extends BaseAsyncReducerState{
    properties?: UserProperty[];
    property_is_shared?: Record<string, string>[];
    redirects?: boolean;
}

// Define an initial state value for the app
const initialState: PropertyListState = {
    loading: false,
    error: false,
    redirects: true
}

export interface UserProperty {
    user_profile_id: string,
    roll_num: string,
    owner_type: "own" | "ten" | "ttl",
    created_at: number,
    reported_at: number,
    address: string,
    city: string,
    active: string,
    notice_owner_name: string,
    property_code: string,
    property_id: string,
    deactivated_at: number,
    bulk_upload: string,
    group_id: string,
    is_shared: string,
    enotif_allowed: string
    enotif_choice: string
}
  
function propertySelectionListReducer(state = initialState, action: AppAction) {

    const { payload, value } = action;

    switch (action.type) {
        case GET_PROPERTY_LIST.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }
        case GET_PROPERTY_LIST.SUCCESS:

            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false,

            }

        case GET_PROPERTY_LIST.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        
        case GET_PROPERTY_LIST.RESET:
            return {
                ...initialState,
                loading: false,
                error: payload
            };

        case SET_REDIRECTS:
            return {
                ...state,
                redirects: value
            }

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default propertySelectionListReducer;